import { NavLink, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { TestContext } from "../../context/testContext";
 
const Header = () => {
  const { currentUser, logout }: any = useContext(AuthContext);
  const { setStatesNull } = useContext(TestContext);
  const navigate = useNavigate();

  const logoutHandler = async () => {
    await logout();
    setStatesNull();
    navigate("/login", { replace: true });
  };

  const activeClass = "header__menu__item_active";
  const defaultClass = "header__menu__item";
  const notAuthNavbar = (
    <>
      <li>
        <NavLink
          to="/login"
          className={({ isActive }) =>
            isActive ? `${defaultClass} ${activeClass}` : defaultClass
          }
        >
          Войти
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/reg"
          className={({ isActive }) =>
            isActive ? `${defaultClass} ${activeClass}` : defaultClass
          }
        >
          Регистрация
        </NavLink>
      </li>
    </>
  );
  let authNavbar;
  if (currentUser) {
    authNavbar = (
      <>
        <li>
          <NavLink
            to="/admin"
            className={({ isActive }) =>
              isActive ? `${defaultClass} ${activeClass}` : defaultClass
            }
          >
            Управление
          </NavLink>
        </li>
        <li>
          <NavLink
            to="#"
            className={defaultClass}
            onClick={logoutHandler}
          > 
            Выйти
          </NavLink>
        </li>
      </>
    );

    if (!currentUser.admin) {
      authNavbar = (
        <>
          <li>
            <NavLink
              to="/test"
              className={({ isActive }) =>
                isActive ? `${defaultClass} ${activeClass}` : defaultClass
              }
            >
              Тестирование
            </NavLink>
          </li>
          <li>
            <NavLink className={defaultClass} onClick={logoutHandler} to="#">
              Выйти
            </NavLink>
          </li>
        </>
      );
    }
  }

  return (
    <header className="header">
      <div className="container">
        <div className="header__wrapper">
          <div className="header__logo">
            {/* <NavLink to="/" className={currentUser ? "disabledComponent": ""}>
              <span>PH-</span>TESTS
            </NavLink> */}
             <NavLink to={currentUser ? (currentUser.admin ? "/admin" : "/test") : "/"}>
              <span>PH-</span>TESTS
            </NavLink>
          </div>
          <ul className="header__menu">
            {!currentUser ? notAuthNavbar : authNavbar}
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
